import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type SmsmessagesCustomerLiveSubscriptionVariables = Types.Exact<{
  customerIds: Array<Types.Scalars['bigint']['input']> | Types.Scalars['bigint']['input'];
}>;


export type SmsmessagesCustomerLiveSubscription = { __typename?: 'subscription_root', smsmessages: Array<{ __typename?: 'smsmessages', id: number, move_id?: number | null, recipient_phone?: string | null, sender_phone?: string | null, message_body?: string | null, createdat?: string | null, updatedat?: string | null, status?: string | null, direction: string, metadata?: object | null, error?: string | null, createdby?: string | null }> };


export const SmsmessagesCustomerLiveDocument = gql`
    subscription smsmessagesCustomerLive($customerIds: [bigint!]!) {
  smsmessages(
    where: {move: {customer_id: {_in: $customerIds}, consumer_pickup: {_eq: true}}}
    order_by: {createdat: desc}
  ) {
    id
    move_id
    recipient_phone
    sender_phone
    message_body
    createdat
    updatedat
    status
    direction
    metadata
    error
    createdby
  }
}
    `;

/**
 * __useSmsmessagesCustomerLiveSubscription__
 *
 * To run a query within a React component, call `useSmsmessagesCustomerLiveSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSmsmessagesCustomerLiveSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmsmessagesCustomerLiveSubscription({
 *   variables: {
 *      customerIds: // value for 'customerIds'
 *   },
 * });
 */
export function useSmsmessagesCustomerLiveSubscription(baseOptions: Apollo.SubscriptionHookOptions<SmsmessagesCustomerLiveSubscription, SmsmessagesCustomerLiveSubscriptionVariables> & ({ variables: SmsmessagesCustomerLiveSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SmsmessagesCustomerLiveSubscription, SmsmessagesCustomerLiveSubscriptionVariables>(SmsmessagesCustomerLiveDocument, options);
      }
export type SmsmessagesCustomerLiveSubscriptionHookResult = ReturnType<typeof useSmsmessagesCustomerLiveSubscription>;
export type SmsmessagesCustomerLiveSubscriptionResult = Apollo.SubscriptionResult<SmsmessagesCustomerLiveSubscription>;